import React , {useEffect, useState} from 'react';
import { TitleBar } from './appBar';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import {FontAwesome, FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faOctagon, faCircle, faClock } from '@fortawesome/free-solid-svg-icons'
import { IconCell,StatusIcons } from './helpers';

export const BigBoard=()=>{
    const [listData,setListData]=useState([]);
    const [update,setUpdate]=useState(new Date().toLocaleTimeString());
    const getData=()=>{
        const url = "api/index.php/program/getAdminPAList";
        //console.log(url);
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(data=>{
            //console.log(data);
            setTime();
            setListData(data);
        })
    }

    const setTime=()=>{
        setUpdate(new Date().toLocaleTimeString());
    }

    const TimeCell = (props) => {
        const retVal = ()=>{
            switch (props.dataItem.Status){
                case "OPEN":
                    //console.log("OPEN");
                    if (props.dataItem.WaitTime<5){
                        return(
                            <span>Less than 5 min</span>
                        )
                    }else{
                        return(
                            <span>{props.dataItem.WaitTime} min</span>
                        )
                    }
                case "CLOSED":
                    //console.log("Closed");
                    return(
                        <span>Closed</span>
                    )
                case "CAPACITY":
                    //console.log("Closed");
                    return(
                        <span>AT CAPACITY</span>
                    )
                case "HOLD":
                    //console.log("HOLD");
                    return(
                        <span>ON HOLD</span>
                    )
                default:
                    return(
                        <span>Closed</span>
                    )
            }
        }
        return (
            <td {...props.tdProps}>
                {retVal()}
            </td>
        );
    };

    useEffect(()=>{
        getData();
        const interval = setInterval(getData, 120000); // Fetch every 2 minutes
    return () => clearInterval(interval); // Cleanup
    },[])
    return(
         <div>
             <div style={{padding:"10px"}}>
                {StatusIcons({status:"OPEN",size:"large"})} OPEN&emsp;
                {StatusIcons({status:"CLOSED",size:"large"})} CLOSED&emsp;               
                {StatusIcons({status:"HOLD",size:"large"})} ON HOLD&emsp;               
                {StatusIcons({status:"CAPACITY",size:"large"})} AT CAPACITY&emsp;
                <span style={{float:"right"}}>Last Update: {update}</span>               
            </div>
            <div style={{padding:"10px"}}>

            <Grid
                data={listData}
                dataItemKey={"AreaID"}
                style={{height:"95vh"}}
            >
                <GridColumn
                    field="Status"
                    title="Status"
                    cells={{data:IconCell}}
                    width={"75px"}
                />
                <GridColumn
                    field="AreaName"
                    title="Area Name"
                />
                <GridColumn
                    field="WaitTime"
                    title="Wait (Minutes)"
                    cells={{data:TimeCell}}
                />
                <GridColumn 
                    title="Participant Count"
                    media="(min-width:768px)" //hidden on mobile
                >
                    <GridColumn
                        field="dailycount"
                        title="Today"
                        width="150px"
                    />
                    <GridColumn
                        field="totalcount"
                        title="Jamboree"
                        width="150px"
                    />
                    <GridColumn
                        field="totaldist"
                        title="Unique Visits"
                        width="150px"
                    />
                </GridColumn>
            </Grid>
            </div>
        </div>
    )
}